import { GridHeaderCellProps } from '@progress/kendo-react-grid';
import { useMemo } from 'react';
import useViewCheckbook from 'src/hooks/useViewCheckbook';
import ExpandCollapseCell from './ExpandCollapseCell';

const CommittedAmountDetailHeaderCell = (props: GridHeaderCellProps) => {
  const { setCommittedAmountData, committedAmountData } = useViewCheckbook();

  const isAllExpanded = useMemo(
    () => committedAmountData.some((glCode) => glCode.expanded),
    [committedAmountData]
  );

  const handleHeaderCellExpand = () => {
    setCommittedAmountData((prev) =>
      [...prev].map((item) => ({ ...item, expanded: !isAllExpanded }))
    );
  };

  return (
    <th className="k-header k-hierarchy-cell" style={{ borderBottomWidth: '0px' }}>
      <ExpandCollapseCell
        expand={isAllExpanded}
        onExpand={handleHeaderCellExpand}
        title="Expand/Collapse All"
      />
    </th>
  );
};

export default CommittedAmountDetailHeaderCell;
